import TierApprovers from 'modules/risk-management/tier-approvers/Main';
import AssessmentTemplates from 'modules/risk-management/assessment-templates/Main';
import RiskAssessments from 'modules/risk-management/risk-assessments/Main';
import RiskRegister from 'modules/risk-management/risk-register/List';
import RiskManagementWrapper from 'modules/risk-management/Main';
import AddRegisterRisk from 'modules/risk-management/risk-register/add-register/Main';
import RiskOverview from 'modules/risk-management/risk-overview/Main';
import RiskAssessmentDetail from 'modules/risk-management/risk-assessments/risk-assessments-detail/Main';
import RiskRegisterDetail from 'modules/risk-management/risk-register/detail-view/Main';
import RiskRegisterWrapper from 'modules/risk-management/risk-register/Wrapper';
import RiskTemplateBuilder from 'modules/risk-management/assessment-templates/add-risk-assessment-template/Main';
// import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';
import AssessmentTemplatesWrapper from 'modules/risk-management/assessment-templates/AssessmentTemplatesWrapper';
import ExternalRiskAssessment from 'modules/risk-management/external-assessments/Main';

const RiskManagementRoutes = (): any => ({
  path: '',
  element: <RiskManagementWrapper />,
  children: [
    {
      path: 'risk-register',
      element: <RiskRegisterWrapper />,
      children: [
        {
          path: '',
          element: <RiskRegister />,
        },
        {
          path: 'add',
          element: <AddRegisterRisk />,
        },
        {
          path: 'edit/:riskId',
          element: <AddRegisterRisk />,
        },
        {
          path: 'detail/:riskId',
          element: <RiskRegisterDetail />,
        },
      ],
    },

    {
      path: 'risk-overview',
      element: <RiskOverview />,
    },

    {
      path: 'risk-assessments',
      element: <RiskAssessments />,
    },
    {
      path: 'risk-assessments/:assessmentId/:mode',
      element: <RiskAssessmentDetail />,
    },
    {
      path: 'external-assessments',
      element: <ExternalRiskAssessment />,
    },
    {
      path: 'assessment-templates',
      element: <AssessmentTemplatesWrapper />,
      children: [
        {
          index: true,
          element: <AssessmentTemplates />,
        },
        {
          path: 'add',
          element: <RiskTemplateBuilder />,
        },
        {
          path: 'edit/:templateId',
          element: <RiskTemplateBuilder />,
        },
      ],
    },
    {
      path: 'tier-approvers',
      element: <TierApprovers />,
    },
    // {
    //     path: 'security',
    //     element: <UserSecurityPage />,
    // },
  ],
});

export default RiskManagementRoutes;
